<template>
  <div
    ref="rootEl"
    class="bg-[#FFF1CC] flex items-center mb-6 shadow-sm welcome-banner relative rounded-3xl bg-cover xl:bg-contain bg-right bg-no-repeat"
    :class="
      variant === 'buyer'
        ? 'h-[132px] py-3 px-5 sm:px-6 sm:py-3.5 md:px-12 md:py-3'
        : 'h-[200px] p-6 sm:p-8 md:px-12 md:py-16'
    "
    :style="{ backgroundImage: `url('/images/bg-welcome-banner.png')` }"
  >
    <button
      type="button"
      @click="dismissWelcome"
      class="absolute top-3 right-3 focus:outline-none focus:ring-2 focus:ring-gray-300"
      :disabled="dismissing"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6L6 18M6 6L18 18"
          stroke="#265957"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <div class="relative">
      <template v-if="variant === 'buyer'">
        <h2 class="mb-2 text-xl font-bold text-brand-600 md:text-2xl">
          Welcome to Salary Matrix
        </h2>
        <p class="text-sm font-normal text-gray-900 sm:text-base">
          You're all set up. To get started, add the producers in your supply chain.
        </p>
      </template>
      <template v-else>
        <h2 class="mb-2 text-xl font-bold text-brand-600 md:text-2xl">
          <Translation
            name="welcome_banner.title"
            default="Welcome to Salary Matrix"
          />
        </h2>
        <p class="text-sm font-normal text-gray-900 sm:text-base">
          <Translation
            name="welcome_banner.subtitle"
            default="Your starting point to measure and close living wage gaps."
          />
        </p>
        <p class="text-sm font-normal text-gray-900 sm:text-base">
          <Translation
            name="welcome_banner.description"
            default="Follow the steps below to get started."
          />
        </p>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import {
  animateRemoveWelcomeBanner,
  requestDismissWelcome,
} from "../lib/dismiss_welcome_banner";

defineProps({
  variant: {
    type: String,
    default: "producer",
    validator: (v) => ["producer", "buyer"].includes(v),
  },
});

const dismissing = ref(false);
const rootEl = ref(null);

const dismissWelcome = async () => {
  if (dismissing.value) return;

  dismissing.value = true;

  try {
    const response = await requestDismissWelcome();

    if (response.ok) {
      animateRemoveWelcomeBanner(rootEl.value);
    } else {
      dismissing.value = false;
    }
  } catch {
    dismissing.value = false;
  }
};
</script>
